import { Stack } from '@mui/material'
import { useListDriversQuery } from '../../../../store/drivers/drivers.api'
import DriverListItem from './driver-list-item/driver-list-item.component'
import { Driver } from '../../../../store/drivers/drivers.type'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedDriver } from '../../../../store/drivers/drivers.slice'
import { useContext, useEffect, useMemo } from 'react'
import { DriverContext } from '../../driver.provider'
import { RootState } from '../../../../store'
import { getUserId } from 'utils/common'

const DriverList = () => {
  const dispatch = useDispatch()
  const { setDriver } = useContext(DriverContext)
  const userId = getUserId()

  const { data: drivers, refetch } = useListDriversQuery(
    { userId },
    { skip: !userId }
  )

  const selectedDriver = useSelector(
    (state: RootState) => state.drivers.selectedDriver
  )

  const sortedDrivers = useMemo(() => {
    if (!drivers) return []
    return [...drivers]
      .filter(
        (driver) => driver.driverAppStatus?.toUpperCase() !== 'INACTIVE'
      )
      .sort((a, b) => {
        const rank = (status?: string | null) =>
          status?.toUpperCase() === 'ACTIVATED' ? 0 : 1
        return rank(a.driverAppStatus) - rank(b.driverAppStatus)
      })
  }, [drivers])

  const handleDriverSelect = (driver: Driver) => {
    dispatch(setSelectedDriver(driver))
    setDriver(driver)
  }

  useEffect(() => {
    refetch()
  }, [refetch])

  useEffect(() => {
    if (!sortedDrivers.length) return
    const stillSelected = sortedDrivers.some(
      (driver) => driver.id === selectedDriver?.id
    )
    if (!stillSelected) {
      dispatch(setSelectedDriver(sortedDrivers[0]))
      setDriver(sortedDrivers[0])
    }
  }, [dispatch, selectedDriver?.id, setDriver, sortedDrivers])

  return (
    <Stack>
      {sortedDrivers.map((driver) => (
        <DriverListItem
          key={driver?.id}
          driver={driver}
          isSelected={selectedDriver?.id === driver?.id}
          handleDriverSelect={() => handleDriverSelect(driver)}
        />
      ))}
    </Stack>
  )
}

export default DriverList
